import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getAllColumnsApi,
  getIndividualClientColumnListApi,
  assignColumnsToClientsApi,
  addInvoiceApi,
  getExpensesInvoiceListApi,
  getRevenueInvoiceListApi,
  getOtherEntriesListApi,
  viewInvoiceApi,
  editInvoiceApi,
  deleteInvoiceApi,
  deleteDocumentApi,
  downloadInvoice,
  getDocumentList,
  invoiceBulkUpload,
} from "@/apis/invoicingApis";

import type {
  AddInvoicePayloadType,
  AssignColumnType,
  GetClientColumnPayload,
  GetInoviceListTypePayload,
} from "@/commonTypes/invoicingTypes";

export const getAllColumnsAction = createAsyncThunk(
  "invoicing/getAllColumns",
  async (token: string) => {
    const response = await getAllColumnsApi(token);
    return response.data;
  }
);

export const getIndividualClientColumnAction = createAsyncThunk(
  "invoicing/getClientColumnList",
  async (data: GetClientColumnPayload) => {
    const response = await getIndividualClientColumnListApi(data);
    return response.data;
  }
);

export const assignColumnsToClientAction = createAsyncThunk(
  "invoicing/assignColumnsToClient",
  async (data: AssignColumnType) => {
    const response = await assignColumnsToClientsApi(data);
    return response.data;
  }
);

export const addInvoiceAction = createAsyncThunk(
  "invoicing/addInvoice",
  async (data: AddInvoicePayloadType) => {
    const response = await addInvoiceApi(data);
    return response.data;
  }
);

export const viewInvoiceAction = createAsyncThunk(
  "/invoicing/viewInvoice",
  async (data: any) => {
    const response = await viewInvoiceApi(data);
    return response.data;
  }
);

export const editInvoiceAction = createAsyncThunk(
  "/invoicing/editInvoice",
  async (data: any) => {
    const response = await editInvoiceApi(data);
    return response.data;
  }
);
export const deleteInvoiceAction = createAsyncThunk(
  `/invoicing/deleteInvoice`,
  async (data: any) => {
    const response = await deleteInvoiceApi(data);
    return response.data;
  }
);
export const deleteDocumentAction = createAsyncThunk(
  `/invoicing/deleteDocument`,
  async (data: any) => {
    const response = await deleteDocumentApi(data);
    return response.data;
  }
);

export const getExpensesInvoiceListAction = createAsyncThunk(
  "invoicing/getExpensesInvoiceList",
  async (data: GetInoviceListTypePayload) => {
    const response = await getExpensesInvoiceListApi(data);
    return response.data;
  }
);

export const getDocumentListAction = createAsyncThunk(
  `/document/getDocumentList`,
  async (data: any) => {
    const response = await getDocumentList(data);
    return response.data;
  }
);

export const getRevenueInvoiceListAction = createAsyncThunk(
  "invoicing/getRevenueInvoiceList",
  async (data: GetInoviceListTypePayload) => {
    const response = await getRevenueInvoiceListApi(data);
    return response.data;
  }
);
export const getOtherEntriesListAction = createAsyncThunk(
  "invoicing/getOtherEntriesList",
  async (data: GetInoviceListTypePayload) => {
    const response = await getOtherEntriesListApi(data);
    return response.data;
  }
);

export const downloadInvoiceAction = createAsyncThunk(
  `invoicing/downloadInvoice`,
  async (data: any) => {
    const response = await downloadInvoice(data);
    return response.data;
  }
);

export const invoiceBulkUploadAction = createAsyncThunk(
  `upload/client/invoice`,
  async (data: any) => {
    const response = await invoiceBulkUpload(data);
    return response;
  }
);
